
import { fetchAuthSession } from 'aws-amplify/auth';
import { BedrockAgentRuntimeClient, InvokeAgentCommand } from "@aws-sdk/client-bedrock-agent-runtime"
import PutStories from '../MyLibrary/putStories';

const TextCorrection = async (setStories, stories, story, badStory, setClientSecret, productType) => {
    const session = await fetchAuthSession()
    // console.log(session)

    const bedrockClient = new BedrockAgentRuntimeClient({
        region: 'us-east-1',
        credentials: session.credentials
    });

    let prompt = "The following story was provided in the wrong format. Here is the correct json format: {id:" + badStory.id + ", description: str, setting: str, character_descriptions: str, title: str" + ", pages: [{text: str }]}. Here is the story you provided:";

    prompt += badStory

    prompt += "Provide the story in the correct format and ensure that the story makes sense."
    // console.log(prompt);


    const params = {
        sessionId: story.id,
        agentId: "9YDI2DNOUZ", // TODO: make .env
        agentAliasId: "SWUOH7GTDO",
        inputText: prompt
    }
    try {
        const command = new InvokeAgentCommand(params);
        const response = await bedrockClient.send(command);
        // console.log('Response from Bedrock agent:', response);
        let completion = ""

        /*     for await (const chunk of stream) {
                console.log(chunk)
            } */

        let decoder = new TextDecoder("utf-8")
        for await (const chunk of response.completion) {
            // console.log("chunk:", chunk)
            const text = decoder.decode(chunk.chunk.bytes)
            completion += text
            // console.log(text)
        }


        // const result = await getProperties({
        //     // `identityId` will provide the ID of the currently authenticated user
        //     path: ({ identityId }) => `private/${identityId}/stories/${story.id}.json`,
        // // });
        // console.log(result)
        const newStory = JSON.parse(completion)
        newStory.productType = productType;
        newStory.mods = 0;


        setStories([...stories, newStory])
        PutStories(story.id, JSON.stringify(newStory))
        localStorage.removeItem('story_time.json')
        setClientSecret(null)
        return completion
    } catch (error) {
        console.error('Error calling Bedrock agent:', error);
    }
};

export default TextCorrection;